import { fetchApiDataV2, fetchApiData } from "../../utils/utils"

export const getShowsByCategory = async (appInfo, key) => {
    const api = key ? `smartHome/${key}` : `home`;
    return await fetchApiDataV2(appInfo, api);
};

